export default __webpack_public_path__ + "static/media/1947.c07a794a.png";